module.exports = "<div *ngIf=\"htmlContentReady\" id=\"#end-of-test-page\">\r\n    <section id=\"end-of-test-page-instructions\">\r\n        <hr>\r\n        <p>This is the end of the {{testName}}.</p>\r\n        <span class=\"reset-test\" (click)=\"resetTest()\">Restart Test</span>\r\n        <hr>\r\n        <div [innerHTML]=endOfTestDescription></div>\r\n    </section>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-end-of-test/ipp-end-of-test.component.html
// module id = mB9l
// module chunks = 1